import { render, staticRenderFns } from "./list.vue?vue&type=template&id=a273768c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "../assets/css/list.scss?vue&type=style&index=0&id=a273768c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a273768c",
  null
  
)

export default component.exports